module.exports = __webpack_public_path__ + "img/logo-batista-agronegocio.jpg";